import { Box } from "@mui/material";
import styled from "styled-components";

export const NavbarStyled = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  /* background-color: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */

  @media (max-width: 768px) {
    padding: 9px 24px !important;
    .web-title {
      display: none;
    }
    .user-email{
      display: none;
    }
  }
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 7.36px;
  .MuiTypography-root {
    font-weight: 700;
    font-size: 18px;
    font-family: "Plus Jakarta Sans", sans-serif !important;
  }
`;

export const UserDropdownStyled = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
  .settings-icon {
    img {
      display: block;
    }
  }
  .cs-dropdown {
    height: 40px;
    padding: 4px 8px 4px 12px !important;
    border-radius: 8px !important;
  }
`;

export const UserDropdownMenu = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  .user-name {
    color: var(--royal-blue-color);
    font-weight: 500;
    font-size: 12px;
  }
  .user-email {
    color: var(--medium-gray-color);
    font-weight: 400;
    font-size: 11px;
  }
  .caret-container {
    svg {
      display: block;
      color: var(--royal-blue-color);
    }
  }
`;
